import { useState } from "react";
import "./OrdersTable.css";

import OrderRow from "../OrderRow/OrderRow";
import EmptyOrders from "../EmptyOrders/EmptyOrders";
import OrderDetailsModal from "../OrderDetailsModal/OrderDetailsModal";

function OrdersTable({ orders, updateStatus }) {
  const [selectedOrder, setSelectedOrder] = useState(null);

  if (!orders.length) {
    return <EmptyOrders onRefresh={() => window.location.reload()} />;
  }

  return (
    <>
      <div className="orders-table-card">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order</th>
              <th>Customer</th>
              <th>Food</th>
              <th>Qty</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Time</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {orders.map((order) => (
              <OrderRow
                key={order._id}
                order={order}
                updateStatus={updateStatus}
                onView={setSelectedOrder}
              />
            ))}
          </tbody>
        </table>
      </div>

      <OrderDetailsModal
        open={selectedOrder !== null}
        order={selectedOrder}
        onClose={() => setSelectedOrder(null)}
      />
    </>
  );
}

export default OrdersTable;